import React from "react";
import { Card, CardMedia, makeStyles } from "@material-ui/core";
import black from "../../../black.jpg";
import { RouteComponentProps, withRouter } from "react-router-dom";

const useStyles = makeStyles({
    root: {
        width: 228,
        marginRight: 24,
        borderRadius: 12,
    },
    media: {
        height: 141,
        position: "relative",
    },
    text: {
        position: "absolute",
        width: "100%",
        textAlign: "center",
        bottom: 16,
        color: "#ffffff",
    },
});

export type CategoryProps = {
    genre: string;
    imagePath: string;
};

const CategoryCard: React.FC<CategoryProps & RouteComponentProps> = (props) => {
    const classes = useStyles();

    return (
        <div>

        <Card
            className={classes.root}
            onClick={() =>
                props.history.push("/producer/category/" + props.genre)
            }
        >
            <CardMedia
                className={classes.media}
                image={
                    !!props.imagePath
                        ? "https://apis.serendipitymedia.tech/assets" +
                          props.imagePath
                        : black
                }
            >
                <div className={classes.text}>{props.genre}</div>
            </CardMedia>
        </Card>
        </div>
    );
};

export default withRouter(CategoryCard);
